import ALL_LANGUAGES from '../../constants/languages';

export default function () {
	try {
		return import.meta.env.VITE_SUPPORTED_LOCALES.split(',');
	} catch (e) {
		return ALL_LANGUAGES.map(lang => lang.code);
	}
}
